// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"ba62e1db","551":"b53b7f11"}[chunkId] + ".chunk.js";
};